import type { SpinProps as AntdSpinProps } from 'antd'
import { Spin as AntdSpin } from 'antd'

interface SpinProps {
  className?: string
}

export default function Spin({ className, ...props }: SpinProps & AntdSpinProps) {
  return (
    <div className={`w-full flex justify-center items-center my-24 ${className || ''}`}>
      <AntdSpin size="middle" {...props} />
    </div>
  )
}
